import React, { useState, useEffect, useRef } from "react";
import "./TimeCarousel.css";
import c1 from "../../assets/hero1.jpg";
import c2 from "../../assets/hero2.jpg";
import c3 from "../../assets/hero3.jpg";
import c4 from "../../assets/hero4.jpg";
import c5 from "../../assets/hero5.jpg";
import c6 from "../../assets/hero6.jpg";
import c7 from "../../assets/hero7.jpg";
import c8 from "../../assets/hero8.jpg";
import c9 from "../../assets/hero9.jpg";
import c10 from "../../assets/hero10.jpg";
const timelineData = [
  { year: "Inception", color: "#cd92fc", images: [c1, c7, c3] },
  { year: "Transformation", color: "#a11df8", images: [c5, c4, c9] },
  { year: "Growth", color: "#901bf7", images: [c10, c2, c6] },
  { year: "Success", color: "#5d048e", images: [c8, c2, c1] },
];

const TimeCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [visitedYear, setVisitedYear] = useState([0]);
  const visitedRef = useRef([0]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);

    const intervalTime = isMobile ? 6000 : 4000;
    const interval = setInterval(() => {
      setActiveIndex((prev) => {
        const nextIndex = prev === timelineData.length - 1 ? 0 : prev + 1;

        if (nextIndex === 0) {
          visitedRef.current = [0];
          setVisitedYear([0]);
        } else {
          updateVisited(nextIndex);
        }

        return nextIndex;
      });
    }, intervalTime);

    return () => {
      clearInterval(interval);
      window.removeEventListener("resize", handleResize);
    };
  }, [isMobile]);


  const updateVisited = (newIndex) => {
    if (!visitedRef.current.includes(newIndex)) {
      visitedRef.current.push(newIndex);
      setVisitedYear([...visitedRef.current]);
    }
  };

  const handlePrev = () => {
    const newIndex = activeIndex === 0 ? timelineData.length - 1 : activeIndex - 1;
    setActiveIndex(newIndex);
    updateVisited(newIndex);
  };

  const handleNext = () => {
    const newIndex = activeIndex === timelineData.length - 1 ? 0 : activeIndex + 1;

    if (newIndex === 0) {
      visitedRef.current = [0];
      setVisitedYear([0]);
    } else {
      updateVisited(newIndex);
    }

    setActiveIndex(newIndex);
  };


  return (
    <>
      <h2 className="timeline_heading" style={{color:'#6e0e5e'}}>Collaboration Over Hierarchy </h2>
      <div className="timeline_subheading">
        <span>A Culture of Continuous Growth </span>
      </div>

      <div className="timeline-carousel">
        <div className="image-wrapper">
          <div className="images-container">
            {isMobile ? (
              <img
                src={timelineData[activeIndex].images[0]}
                alt="single-slide"
                className="carousel-img"
              />
            ) : (
              timelineData[activeIndex].images.map((img, i) => (
                <img key={i} src={img} alt={`slide-${i}`} className="carousel-img" />
              ))
            )}
          </div>
        </div>

        <div className="timeline">
          <div className="line">
            {timelineData.map((item, index) => {
              const isActive = index === activeIndex;
              return (
                <div
                  key={index}
                  className="year-wrapper"
                  onClick={() => {
                    setActiveIndex(index);
                    updateVisited(index);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <span
                    className="dot"
                    style={{
                      backgroundColor: visitedYear.includes(index)
                        ? item.color
                        : "#a7a7a7",
                      border: isActive ? "2px solid #000" : "none",
                    }}
                  ></span>
                  <span
                    className="year"
                    style={{
                      color: isActive ? item.color : "#a7a7a7",
                      fontWeight: isActive ? "bold" : "normal",
                    }}
                  >
                    {item.year}
                  </span>
                </div>
              );
            })}
            <div
              className="progress"
              style={{
                width: `${(activeIndex / (timelineData.length - 1)) * 100}%`,
                backgroundColor: timelineData[activeIndex].color,
              }}
            ></div>
          </div>
        </div>

        <div className="nav-buttons">
          <button onClick={handlePrev} className="nav-btn">‹</button>
          <button onClick={handleNext} className="nav-btn">›</button>
        </div>
      </div>
    </>
  );
};

export default TimeCarousel;
